import React, { FC } from 'react';
import { getEvolutionLineChartConfig } from './getEvolutionLineChartConfig';
import { EnterpriseData } from '../../entity.types';
import { LazyReactChart } from '../LazyReactChart';
import { DataSet } from '../getLineChartConfig';

type OnChartClickType = (
  event: MouseEvent,
  data: DataSet & {
    customMetadatas?: { raisonSociale: string; enterpriseId: string };
  },
  year: string,
) => void;

type Props = {
  enterpriseDatas: EnterpriseData;
  oppositesEnterpriseDatas?: Array<EnterpriseData>;
  handleClick: OnChartClickType;
};

export const EvolutionChart: FC<Props> = ({
  handleClick,
  enterpriseDatas,
  oppositesEnterpriseDatas = [],
}) => {
  if (
    enterpriseDatas.chronology.caseData.caseCounts.length === 0 ||
    !enterpriseDatas.chronology.caseData.caseCounts.some((d) => d > 0)
  ) {
    return null;
  }

  return (
    <LazyReactChart
      width="250"
      height="150"
      config={getEvolutionLineChartConfig({
        oppositesEnterpriseDatas,
        enterpriseDatas,
        onChartClick: handleClick,
      })}
    />
  );
};
